import React from 'react'
import ReactDom from 'react-dom'
import 'babel-polyfill'
import { AppContainer } from 'react-hot-loader'
import RootContainer from './features/ui/components/Root'

import {
    setTranslations,
    setDefaultLanguage,
    setLanguageCookie,
    setLanguage,
    getLanguage,
} from 'react-switch-lang';

import en from './wording/en'
import th from './wording/th'

setTranslations({ en, th });

setDefaultLanguage('th');

if (getLanguage() === 'th' || getLanguage() === 'en') {
    setLanguage(getLanguage())
}

setLanguageCookie('language', { maxAge: 86400 }, undefined)

const render = (Component) => {
    return ReactDom.render(
        <AppContainer>
            <Component />
        </AppContainer>,
        document.getElementById('root')
    )
}

render(RootContainer)

if (module.hot){
    module.hot.accept('./features/ui/components/Root', () => render(RootContainer))
}


// WEBPACK FOOTER //
// ./src/index.js